<template>
  <ul class="inquiries__tips">
    <li class="inquiries__tips-item">
      <div class="inquiries__tips-icon">
        <img src="@/assets/shared/img/common/icon-checkbook.svg" alt="" width="32" height="32" />
      </div>
      <h4 class="inquiries__tips-title">フォームに必要事項をご入力ください。</h4>
      <p class="inquiries__tips-text"><a :href="loginUrlAddParams" @click="setFormId">NTT東日本ビジネスIDでログイン</a>すると、申し込み情報の入力を省略することができます。</p>
    </li>
  </ul>
</template>

<script>
export default {
  name: "InquiriesTips",
  props: [
    'loginUrl'
  ],
  computed: {
    loginUrlAddParams() {
      return this.loginUrl;
    }
  },
  methods: {
    setFormId() {
      this.$cookies.set('formId', this.$route.query.formId);

      const query = new URLSearchParams(this.$route.query);
      this.$cookies.set('query', query.toString());
    }
  }
};
</script>
